import React from 'react';

import MediaFiles from './MediaFiles';

export default class TimelineItem extends React.PureComponent {
  render() {
    let {
      item,
    } = this.props;
    let title = item.text;
    let description = typeof item.data == 'string'
      ? item.data
      : item.data?.description;

    return <div className={'mc-flex-col'}>
      <div className={'mc-value-618'}>{title}</div>
      <pre className={'mc-label-416'}>{description}</pre>
      <MediaFiles item={item} imageGroupProps={{template: 3, length: 3}}/>
    </div>;
  }
}
